import React from 'react';
import { Box, Typography, LinearProgress, Grid, Paper } from '@mui/material';
import { FleetStatus } from '../../../services/dashboardService';
import { useTranslation } from 'react-i18next';

interface FleetStatusBarsProps {
  data: FleetStatus;
}

/**
 * Composant pour afficher l'état de la flotte avec des barres de progression
 */
const FleetStatusBars: React.FC<FleetStatusBarsProps> = ({ data }) => {
  const { t } = useTranslation();

  const statusItems = [
    {
      label: t('dashboard:fleetStatus.availableVehicles'),
      value: data.availableVehicles,
      total: data.totalVehicles,
      color: '#4caf50', // green
    },
    {
      label: t('dashboard:fleetStatus.inMaintenance'),
      value: data.inMaintenance,
      total: data.totalVehicles,
      color: '#ff9800', // orange
    },
    {
      label: t('dashboard:fleetStatus.outOfService'),
      value: data.outOfService,
      total: data.totalVehicles,
      color: '#f44336', // red
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      {statusItems.map((item, index) => {
        const percentage = (item.value / item.total) * 100;
        
        return (
          <Paper
            key={index}
            sx={{
              p: 2,
              mb: 2,
              borderRadius: 2,
              boxShadow: 1,
              '&:last-child': { mb: 0 },
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body1">{item.label}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.value}/{item.total} ({percentage.toFixed(0)}%)
                  </Typography>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={percentage}
                  sx={{
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: item.color,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        );
      })}
    </Box>
  );
};

export default FleetStatusBars;